import * as React from 'react';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import { Grid, Button } from '@material-ui/core';

import { CircularProgress } from '@material-ui/core';

import { DocumentCard } from '../components';

import { timestampToString } from '../utils';

type Props = {
  documents: AnyDocument[] | null;
  loading: boolean;
  selectable?: boolean;
  selectedIDs?: string[];
  onFetchMore?: () => void;
  onSelect?: (doc: AnyDocument, checked: boolean) => void;
};

const styles: StyleRulesCallback = theme => ({
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 300
  }
});

class DocumentGrid extends React.Component<Props & WithStyles> {
  renderDocuments(documents: AnyDocument[]) {
    const { selectable, selectedIDs, onSelect } = this.props;
    return documents.map((doc, i) => (
      <Grid key={doc.id} item={true} xs={12} sm={4}>
        <DocumentCard
          kind={doc.kind}
          source={(doc as RasterDocument).sceneSource}
          meanNdvi={doc.meanNdvi}
          date={timestampToString(doc.capturedOn)}
          thumbnailUrl={doc.thumbnailUrl}
          selectable={selectable}
          selected={selectedIDs && selectedIDs.includes(doc.id)}
          onSelect={(evt, checked) => onSelect && onSelect(doc, checked)}
        />
      </Grid>
    ));
  }

  renderLoading() {
    const { classes } = this.props;
    return (
      <Grid item={true} xs={12} className={classes.progressContainer}>
        <CircularProgress size={150} />
      </Grid>
    );
  }

  renderFetchMoreButton(onFetchMore: () => void) {
    const { loading } = this.props;
    return (
      <Grid item={true} xs={12} style={{ textAlign: 'center', marginTop: 10 }}>
        <Button disabled={loading} onClick={onFetchMore}>
          {loading && <CircularProgress size={18} />}
          Cargar Más
        </Button>
      </Grid>
    );
  }

  render() {
    const { documents, loading, onFetchMore } = this.props;
    return (
      <Grid container={true} spacing={24} style={{ maxWidth: 900 }}>
        {!documents && loading && this.renderLoading()}
        {documents && this.renderDocuments(documents)}
        {documents && onFetchMore && this.renderFetchMoreButton(onFetchMore)}
      </Grid>
    );
  }
}

export default withStyles(styles)(DocumentGrid);



// WEBPACK FOOTER //
// ./src/components/DocumentGrid.tsx